import { Component, forwardRef, Renderer2, ViewChild, Input, Output, OnChanges, EventEmitter } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { OfferPrimayAreaService } from '../../../service/offer-primary-area/offer-primary-area.service';
import { sortObjbyName } from '../../../../../theme/functions/sortObjbyName.function';

export const EPANDED_TEXTAREA_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => SelectOfferPrimaryAreaComponent),
  multi: true,
};

@Component({
  selector: 'app-select-offer-primary-area',
  templateUrl: './select-offer-primary-area.component.html',
  styleUrls: ['./select-offer-primary-area.component.scss'],
  providers: [EPANDED_TEXTAREA_VALUE_ACCESSOR],
})
export class SelectOfferPrimaryAreaComponent implements ControlValueAccessor,OnChanges {
    @Input() offerPrimaryAreaId: number;
    @ViewChild('input') textarea;
    @Input() disabled: boolean;
    @Output() offerPrimaryAreaChage = new EventEmitter();

    public offerPrimaryAreaOptions: any[];

    public onChange;
    public onTouched;
    public totalRecords: number;
    public page: number;
    public per_page: number;
    public sort: string;
    public query: string;
    public filters: {key: string, value: string}[];

    constructor(
        private renderer: Renderer2,
        public offerPrimayAreaService: OfferPrimayAreaService
    ) {
        this.page = 1;
        this.per_page = 10;
        this.query = undefined;
        this.filters = [];
    }
    ngOnInit(){
        // this.getofferPrimaryAreas(this.query, this.filters);
    }
    ngOnChanges(){
        this.getofferPrimaryAreas(this.query, this.filters);//this.ngOnInit();
    }
    writeValue(value: any ) {
        const div = this.textarea.nativeElement;
        // this.renderer.setProperty(div, 'textContent', value);
    }

    registerOnChange(fn: any ) {
        this.onChange = fn;
    }

    registerOnTouched(fn: any ) {
        this.onTouched = fn;
    }

    // setDisabledState(isDisabled: boolean ) {
    //     const div = this.textarea.nativeElement;
    //     const action = isDisabled ? 'addClass' : 'removeClass';
    //     this.renderer[action](div, 'disabled');
    // }

    setDisabledState(isDisabled: boolean ) {
        this.disabled = isDisabled;
    }

    public change($event) {
        this.offerPrimaryAreaChage.emit($event.target.value);
        this.onChange($event.target.value);
        this.onTouched($event.target.value);
    }

    getofferPrimaryAreas(query?: string, filters?: any[]) {
        this.offerPrimayAreaService.getOfferPrimaryArea(this.page, this.per_page, this.sort, this.query, this.filters).toPromise().then(
            response => {
                const offerPrimaryAreas = sortObjbyName(response.json().data,'asc');
                this.totalRecords = response.json().meta.total;
                
                this.offerPrimaryAreaOptions = [];
                this.offerPrimaryAreaOptions.push({id: undefined, name: 'choose'});
                offerPrimaryAreas.forEach(element => {
                    if (this.offerPrimaryAreaId == element.id) {
                        this.offerPrimaryAreaOptions.push({id: element.id, name: element.name, selected: true});
                    } 
                    else {
                        this.offerPrimaryAreaOptions.push({id: element.id, name: element.name, selected: false});
                    }
                });
                
            },
            error => {
                this.offerPrimaryAreaOptions = [];
                this.offerPrimaryAreaOptions.push({id: '', name: 'Error'});
            }
        );
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/offer-areas/select-offer-primary-area/select-offer-primary-area.component.ts